import { http } from '../utils/http'

export async function login(params: { phone: string; password: string }) {
  return http.post('/admin/login', params)
}

